import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;
let Day = {
    id: "x-axis-0",
    type: 'time',
    distribution: 'linear',
    spanGaps: true,
    mode: "x",

    gridLines: {
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    time: {
        tooltipFormat:'DD.MM',
        displayFormats: {
            hour: "HH:mm",
            minute: "HH:mm",
            day: "D.M."
        },
        unitStepSize: 1,
        unit: 'day'
    },
    ticks: {
        autoSkip:true,
        fontSize: tickFontSize,
        beginAtZero:false,

        callback: (value, index, values) => {
            return value;
        }
    }
};

export default Day;



// WEBPACK FOOTER //
// ./src/components/chart/axes/Day.js